import type { InputHTMLAttributes } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

export default function Input({
  label,
  error,
  id,
  className = "",
  ...props
}: InputProps) {
  const inputId = id ?? label.toLowerCase().replace(/\s+/g, "-");
  return (
    <div className={className}>
      <label
        htmlFor={inputId}
        className="mb-1.5 block text-base font-medium text-text"
      >
        {label}
      </label>
      <input
        id={inputId}
        className={`w-full rounded-xl border bg-surface px-4 py-3 text-base text-text placeholder:text-text-secondary/50 focus:outline-none focus:ring-2 focus:ring-border-focus ${
          error ? "border-error" : "border-border"
        }`}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-error">{error}</p>}
    </div>
  );
}
